import { customElement, property } from 'lit/decorators.js';
import { html, PropertyValues } from 'lit';
import '@carbon/web-components/es/components/search/search.js';

import Debug from 'debug';
import { PdqTransform } from '../flow/pdq-transform';
import { dataBroker } from '../services/DataBroker';
import { notificationService } from '../services/notificationService';

const log = Debug('pdq:ui:pdq-search');

@customElement('pdq-search')
export class PdqSearch extends PdqTransform {
  @property({ type: String }) search = '';
  @property({ type: String, attribute: 'label-text' }) labelText = '';
  @property({ type: String }) size = 'md';
  @property({ type: String, reflect: true }) value = '';
  @property({ type: String }) placeholder = '';
  @property({ type: Boolean }) disabled = false;

  @property({type: Array}) sources: string[] = []
  @property({ type: String, attribute: 'property-to-match' }) propertyToMatch = '';

  constructor() {
    super();
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    dataBroker.setDataSource(`${this.id}-value`, '');
  }

  render() {
    log('render')
    return html`
      <cds-search
        autocomplete="off"
        ?disabled="${this.disabled}"
        label-text="${this.labelText}"
        placeholder="${this.placeholder}"
        size="${this.size}"
        value="${this.value}"
        @cds-search-input="${this.onInput.bind(this)}">
      </cds-search>
      <slot style="display: none;" name="transform" @slotchange="${this._onSlotChange}"></slot>
    `
  }

  async sync() {
    if ((this.sources?.length || 0) < 1 || !this.id) {
      log('name or sources not set, sync not required')
      return
    }
    const nKey = [...this.sources,this.script?.meta.hash].join('|')
    if (this.cacheKey == nKey) {
      log('sync not required')
      return
    }
    this.cacheKey = nKey
    log(`cacheKey changed, syncing... [${this.cacheKey}]`)

    const sources = new Set<string>(this.sources)
    if (sources.has(this.id)) {
      log('sources includes self... sync aborted.')
      return
    }

    if (this.propertyToMatch) {
      await dataBroker.upsertDerivation(this.id,
        [`${this.id}-value`, ...this.sources],
        this.defaultFilter.bind(this) as (data: any[]) => any)
    } else {
      if (!this.script?.module.transform) {
        log('script does not export a transform function... sync aborted.')
        return
      }
      try {
        await dataBroker.upsertDerivation(this.id,
          [`${this.id}-value`, ...sources],
          this.script.module.transform)
      } catch (e) {
        log(`failed to add derivation: ${e}`)
        notificationService.warning(`failed to add derivation ${this.id}: ${e}`)
      }
    }
  }

  defaultFilter(sources: [string, any, any[]]) {
    const [search, data] = sources
    console.log(`transform: ${search}`, !!search);
    const searchProperty = 'county'
    if (!search)
      return data

    const [partial, ...words] = search.split(' ').reverse()
    const regexes = words ? [...words.map(i => new RegExp(`\\b${i}\\b`, 'i'))] : []
    if (partial) {
      regexes.push(new RegExp(partial.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i'))
    }
    return data.filter((i:any) => regexes.every(r => r.test(i[searchProperty])))
  }

  onInput(evt: CustomEvent){
    log('onInput', evt.detail.value);
    this.value = evt.detail.value;
    dataBroker.setDataSource(`${this.id}-value`, evt.detail.value);
  }
  protected async _onSlotChange(event: Event): Promise<void> {
    this.super._onSlotChange()
    this.sync()
  }
}




